<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-section contact-section">
          <h3><span class="glyphicon glyphicon-phone-alt"></span> 联系我们</h3>
          <ul class="contact-list">
            <li><span class="glyphicon glyphicon-phone"></span> 电话：{{ contactInfo.telephone }}</li>
            <li><span class="glyphicon glyphicon-home"></span> 总部地址：{{ contactInfo.address }}{{ contactInfo.detailedAddress }}</li>
            <li><span class="glyphicon glyphicon-hdd"></span> 机房地址：{{ contactInfo.machineRoomAddress }}</li>
            <li><span class="glyphicon glyphicon-briefcase"></span> 办公地址：{{ contactInfo.officialAddress }}</li>
            <li><span class="glyphicon glyphicon-envelope"></span> 公司邮箱：{{ contactInfo.companyEmail }}</li>
            <li><span class="glyphicon glyphicon-envelope"></span> 客服邮箱：{{ contactInfo.customerEmail }}</li>
          </ul>
        </div>
        <div class="footer-section links-section">
          <h3><span class="glyphicon glyphicon-link"></span> 快速链接</h3>
          <ul class="quick-links">
            <li v-for="(link, index) in quickLinks" :key="index">
              <span class="glyphicon glyphicon-chevron-right"></span>
              <router-link :to="link.path">{{ link.name }}</router-link>
            </li>
          </ul>
        </div>
        <div class="footer-section follow-section">
          <h3><span class="glyphicon glyphicon-qrcode"></span> 关注我们</h3>
          <div class="qrcode">
            <img :src="qrCodeUrl" alt="微信二维码">
            <p>扫码关注公众号</p>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>{{ copyright }}</p>
        <p>{{ icp }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { contactUsList } from '@/api/api'
export default {
  name: 'Footer',
  data() {
    return {
      contactInfo: {
        telephone: '',
        address: '',
        detailedAddress: '',
        machineRoomAddress: '',
        officialAddress: '',
        companyEmail: '',
        customerEmail: ''
      },
      quickLinks: [
        { name: '首页', path: '/' },
        { name: '关于我们', path: '/software/smartTown' },
        { name: '公司业务', path: '/service' },
        { name: '新闻动态', path: '/newsinformation' },
        { name: '人才招聘', path: '/jobchance' },
        { name: '联系我们', path: '/contactus' }
      ],
      qrCodeUrl: require('@/assets/img/bot_01.png'),
      copyright: '© 2024 广东蔚海版权所有',
      icp: '备案号：粤ICP备15057941号-2 粤公网安备 44011502000370号'
    }
  },
  mounted() {
    this.initContactUsList();
  },
  methods: {
    // 初始化联系我们公司信息
    initContactUsList() {
      contactUsList().then(res => {
        console.log(res);
        if (res.data && res.data.companyImage) {
          this.qrCodeUrl = res.data.companyImage;
        }
        this.contactInfo = res.data || this.contactInfo;
      }).catch(err => {
        console.error('获取联系信息失败', err);
      });
    }
  }
}
</script>

<style scoped>
/* 主要样式 */
.footer {
  background-color: #2c3e50;
  color: #fff;
  padding: 40px 0 20px;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;
}

/* 各部分通用样式 */
.footer-section {
  padding: 0;
}

.footer-section h3 {
  margin-bottom: 20px;
  font-size: 18px;
  color: #fff;
  font-weight: 500;
}

.footer-section h3 .glyphicon {
  margin-right: 8px;
  color: #3498db;
}

/* 联系我们部分 */
.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-list li {
  margin: 10px 0;
  color: #ddd;
  display: flex;
  align-items: flex-start;
}

.contact-list .glyphicon {
  color: #3498db;
  margin-right: 10px;
  min-width: 16px;
  margin-top: 3px;
}

/* 快速链接部分 */
.quick-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.quick-links li {
  margin: 10px 0;
  transition: transform 0.3s;
}

.quick-links li:hover {
  transform: translateX(5px);
}

.quick-links .glyphicon {
  color: #3498db;
  margin-right: 8px;
  font-size: 12px;
}

.quick-links a {
  color: #ddd;
  text-decoration: none;
  transition: color 0.3s;
}

.quick-links a:hover {
  color: #3498db;
}

/* 关注我们部分 */
.follow-section {
  text-align: center;
}

.qrcode {
  margin-top: 10px;
  display: inline-block;
}

.qrcode img {
  width: 160px;
  height: 160px;
  background: #fff;
  padding: 4px;
  border-radius: 4px;
}

.qrcode p {
  margin-top: 10px;
  color: #ddd;
  font-size: 14px;
}

/* 底部版权部分 */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  text-align: center;
}

.footer-bottom p {
  margin: 5px 0;
  color: #aaa;
  font-size: 14px;
}

/* 响应式设计 */
@media screen and (max-width: 992px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
  }
  
  .contact-section {
    grid-column: span 2;
  }
}

@media screen and (max-width: 768px) {
  .footer-content {
    display: block;
  }
  
  .footer-section {
    margin-bottom: 30px;
  }
  
  .contact-section {
    width: 100%;
    margin-bottom: 30px;
  }
  
  .links-section,
  .follow-section {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }
  
  .links-section {
    float: left;
  }
  
  .follow-section {
    float: right;
    text-align: center;
  }
  
  .qrcode img {
    width: 140px;
    height: 140px;
  }
  
  /* 清除浮动 */
  .footer-content:after {
    content: "";
    display: table;
    clear: both;
  }
}

@media screen and (max-width: 480px) {
  .footer {
    padding: 30px 0 15px;
  }
  
  .footer-section h3 {
    font-size: 16px;
  }
  
  .contact-list li,
  .quick-links li {
    font-size: 13px;
  }
  
  .qrcode img {
    width: 120px;
    height: 120px;
  }
  
  .footer-bottom p {
    font-size: 12px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue